import React from 'react'
import { Layout, Row, Col, Button } from 'antd'
import { BuildSteps } from 'components/BuildSteps'
import { FinishedPhase } from 'layouts/FinishedPhase'
import { useKaraoke } from 'hooks/karaoke'
import { _STEPS } from 'actions/index'
import { PlaygroundPhase1 } from 'layouts/PlaygroundPhase1'
import { UploadingPhase } from 'layouts/UploadingPhase'
import { PlaygroundSyncLyric } from 'layouts/PlaygroundSyncLyric'
import {PlayCircleOutlined}  from '@ant-design/icons'

import './styles.scss'
import { Link } from 'react-router-dom'

const { Header, Content } = Layout

const PickPlayGround = () => {
  const { currentStep } = useKaraoke()

  switch (currentStep) {
    case _STEPS.UPLOADING:
      return <UploadingPhase />
    case _STEPS.FINISHED:
      return <FinishedPhase />
    case _STEPS.SYNC_LYRIC:
      return <PlaygroundSyncLyric />
    default:
      return <PlaygroundPhase1 />
  }
}

export const LayoutMain = (props) => {
  return (
    <Layout>
      <Header>
        <Row align='middle' justify='center' className='stretched'>
          <Col span={12}>
            <BuildSteps />
          </Col>
        </Row>
        <Link className='switcher' to='/player' component={Button} type='primary' icon={<PlayCircleOutlined />}>Player</Link>
      </Header>
      <Content className='container'>
        <PickPlayGround />
      </Content>
    </Layout>
  )
}
